// utils/toast.ts
import { store } from "../../application/store";
import { showToast } from "../../application/features/common/toasterSlice";
export const toast = {
    success: (message) => {
        store.dispatch(showToast({ message, severity: 'success' }));
    },
    error: (message) => {
        store.dispatch(showToast({ message, severity: 'error' }));
    },
    info: (message) => {
        store.dispatch(showToast({ message, severity: 'info' }));
    },
    warning: (message) => {
        store.dispatch(showToast({ message, severity: 'warning' }));
    },
};
